module.exports = __webpack_public_path__ + "static/media/zodiac-capricon.0836581a.png";